<template>
  <div class="pfa-list">
    <!-- 热门推荐 -->
    <div class="hot-recommend">
      <div class="hot-header">
        <div class="hot-title">热门推荐</div>
      </div>
      <div v-if="visibleHotList.length > 0" class="hot-scroll">
        <div ref="hotScrollEl" class="hot-scroll-inner">
          <div class="hot-scroll-list">
            <div
              v-for="(item, index) in hotScrollList"
              :key="`${item.id || item.baseId || item.materialId || 'hot'}-${index}`"
              class="hot-item"
              @click="goDetail(item, {fromHotRecommend: true})"
            >
              <div class="hot-image">
                <img :src="item._cover" alt="" loading="lazy"/>
                <div class="hot-tag">HOT</div>
              </div>
              <div class="hot-item-title">
                <span v-if="item._typeName" class="hot-title-type">{{ item._typeName }}</span>
                <span class="hot-title-text">{{ item._title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="hot-empty-wrapper">
        <EmptyView class="hot-empty-view" title="暂无数据" :description="''"/>
      </div>
    </div>

    <!-- 搜索栏（位于标签页之上） -->
    <div class="tabs-search-bar">
      <van-search
        v-model="searchValue"
        :clearable="true"
        clear-trigger="always"
        placeholder="请输入课程、文献等"
        @search="onSearchEnter"
        @clear="clearSearchValue"
        @click.native="handleSearchClick"
      />
    </div>

    <!-- 标签页 -->
    <van-tabs
      ref="pfaTabs"
      class="pfa-tabs"
      :active="`${courseCategoryIdFirst}`"
      :ellipsis="false"
      :swipe-threshold="1"
      line-width="0"
      line-height="0"
      title-active-color="#1A1A1A"
      title-inactive-color="#343434"
      @click="onTabClick"
    >
      <van-tab
        v-for="item in categoryList"
        :key="item.id"
        :name="`${item.id}`"
      >
        <div slot="title" class="pfa-tab-title">
          <span class="pfa-tab-title-text" style="font-size: 14px !important;">{{ item.name }}</span>
          <img v-if="`${courseCategoryIdFirst}` === `${item.id}`" src="@/assets/images/training/img(6).png" class="img-btm" alt="">
        </div>
      </van-tab>
    </van-tabs>

    <!-- 内容区域 -->
    <div class="content-wrapper">
      <!-- 左侧分类树 -->
      <div class="category-tree">
        <DatabaseLeftMenu
          ref="DatabaseLeftMenu"
          :menu-list="categoryList"
          :wrap-text="true"
          track-prefix="PFA图书馆-"
          :course-category-id-first.sync="courseCategoryIdFirst"
          :course-category-id-second.sync="courseCategoryIdSecond"
          :course-category-id-third.sync="courseCategoryIdThird"
          @defaultList="defaultList"
        />
      </div>

      <!-- 右侧内容列表 -->
      <div class="content-list">
        <template v-if="sectionList.length > 0">
          <div class="section-accordion">
            <div
              v-for="section in sectionList"
              :key="section.id"
              class="section-item"
            >
              <div
                class="section-title"
                :class="{ active: activeSectionId === section.id }"
                @click="toggleSection(section)"
              >
                <div class="section-title-main">
                  <span class="section-title-text">
                    <img class="section-title-text-icon" src="@/assets/images/title.svg" alt=""/>
                    {{ section.name }}
                  </span>
                  <span class="section-title-action">
                    {{ activeSectionId === section.id ? '收起' : '展开' }}
                    <img
                      src="@/assets/images/expand.svg"
                      class="section-title-action-icon"
                      :class="{ reverse: activeSectionId !== section.id }"
                      alt=""
                    />
                  </span>
                </div>
              </div>
              <template v-if="activeSectionId === section.id">
                <van-list
                  v-if="contentList.length > 0"
                  :loading="state.loading"
                  :finished="state.finished"
                  :finished-text="state.finishText"
                  @load="getContentList"
                >
                  <div
                    v-for="course in contentList"
                    :key="course.id"
                    class="content-box"
                  >
                    <div class="content-box-item">
                      <div
                        class="content-item"
                        :data-pfa-item-key="getItemDomKey(course)"
                        @click="goDetail(course)"
                      >
                        <div class="content-image">
                          <img :src="course._cover" alt=""/>
                          <div class="content-type-tag">
                            <img :src="course._typeIcon" class="tag-icon" alt=""/>
                            {{ course._typeName }}
                          </div>
                        </div>
                        <div class="content-info">
                          <div class="content-title">{{ course.name }}</div>
                          <div v-if="course.lecturerHospitals" class="content-meta">医院：{{ course.lecturerHospitals }}</div>
                          <div class="content-meta-row"><span v-if="course.lecturers">{{ course.type === 2 ? '讲师' : '作者' }}：{{ course.lecturers }}</span></div>
                          <div v-if="`${course.isUnlock}` === '1' && !course.myUnlock" class="item-unlock">
                            <img src="@/assets/images/data-base/unlock.png" class="icon-unlock" alt=""/>
                            <span>{{ course.unlockCost }}积分解锁</span>
                          </div>
                        </div>
                      </div>
                      <template v-if="course.courseMaterialList && course.courseMaterialList.length">
                        <div class="material-toggle" @click.stop="toggleMaterial(course.id)">
                          <van-icon
                            name="arrow-down"
                            class="material-toggle-icon"
                            :class="{ expanded: expandedMaterialIds.indexOf(course.id) !== -1 }"
                          />
                        </div>
                        <template v-if="expandedMaterialIds.indexOf(course.id) !== -1">
                          <div
                            v-for="item in course.courseMaterialList"
                            :key="item.id"
                            class="content-item"
                            :data-pfa-item-key="getItemDomKey(item)"
                            @click="goDetail(item)"
                          >
                            <div class="content-image">
                              <img :src="item._cover" alt=""/>
                              <div class="content-type-tag">
                                <img :src="item._typeIcon" class="tag-icon" alt=""/>
                                {{ item._typeName }}
                              </div>
                            </div>
                            <div class="content-info">
                              <div class="content-title">{{ item.title }}</div>
                              <div v-if="isCaseMaterial(item) && getCaseMaterialHospital(item)" class="content-meta">
                                医院：{{ getCaseMaterialHospital(item) }}
                              </div>
                              <div v-if="isCaseMaterial(item) && getCaseMaterialAuthor(item)" class="content-meta-row">
                                <span>作者：{{ getCaseMaterialAuthor(item) }}</span>
                              </div>
                              <div v-if="`${item.isUnlock}` === '1' && !item.myUnlock" class="item-unlock">
                                <img src="@/assets/images/data-base/unlock.png" class="icon-unlock" alt=""/>
                                <span>{{ item.unlockCost }}积分解锁</span>
                              </div>
                            </div>
                          </div>
                        </template>
                      </template>
                    </div>
                  </div>
                </van-list>
                <div v-else-if="state.showEmptyView" class="empty-wrapper">
                  <EmptyView class="empty-view" :title="emptyViewTitle" :description="''"/>
                </div>
              </template>
            </div>
          </div>
        </template>
        <template v-else>
          <van-list
            v-if="contentList.length > 0"
            :loading="state.loading"
            :finished="state.finished"
            :finished-text="state.finishText"
            @load="getContentList"
          >
            <template>
              <div
                v-for="course in contentList"
                :key="course.id"
                class="content-box"
              >
                <div class="content-box-item">
                  <div
                    class="content-item"
                    :data-pfa-item-key="getItemDomKey(course)"
                    @click="goDetail(course)"
                  >
                    <div class="content-image">
                      <img :src="course._cover" alt=""/>
                      <div class="content-type-tag">
                        <img :src="course._typeIcon" class="tag-icon" alt=""/>
                        {{ course._typeName }}
                      </div>
                    </div>
                    <div class="content-info">
                      <div class="content-title">{{ course.name }}</div>
                      <div v-if="course.lecturerHospitals" class="content-meta">医院：{{ course.lecturerHospitals }}</div>
                      <div class="content-meta-row"><span v-if="course.lecturers">{{ course.type === 2 ? '讲师' : '作者' }}：{{ course.lecturers }}</span></div>
                      <div v-if="`${course.isUnlock}` === '1' && !course.myUnlock" class="item-unlock">
                        <img src="@/assets/images/data-base/unlock.png" class="icon-unlock" alt=""/>
                        <span>{{ course.unlockCost }}积分解锁</span>
                      </div>
                    </div>
                  </div>
                  <template v-if="course.courseMaterialList && course.courseMaterialList.length">
                    <div class="material-toggle" @click.stop="toggleMaterial(course.id)">
                      <van-icon
                        name="arrow-down"
                        class="material-toggle-icon"
                        :class="{ expanded: expandedMaterialIds.indexOf(course.id) !== -1 }"
                      />
                    </div>
                    <template v-if="expandedMaterialIds.indexOf(course.id) !== -1">
                      <div
                        v-for="item in course.courseMaterialList"
                        :key="item.id"
                        class="content-item"
                        :data-pfa-item-key="getItemDomKey(item)"
                        @click="goDetail(item)"
                      >
                        <div class="content-image">
                          <img :src="item._cover" alt=""/>
                          <div class="content-type-tag">
                            <img :src="item._typeIcon" class="tag-icon" alt=""/>
                            {{ item._typeName }}
                          </div>
                        </div>
                        <div class="content-info">
                          <div class="content-title">{{ item.title }}</div>
                          <div v-if="isCaseMaterial(item) && getCaseMaterialHospital(item)" class="content-meta">
                            医院：{{ getCaseMaterialHospital(item) }}
                          </div>
                          <div v-if="isCaseMaterial(item) && getCaseMaterialAuthor(item)" class="content-meta-row">
                            <span>作者：{{ getCaseMaterialAuthor(item) }}</span>
                          </div>
                          <div v-if="`${item.isUnlock}` === '1' && !item.myUnlock" class="item-unlock">
                            <img src="@/assets/images/data-base/unlock.png" class="icon-unlock" alt=""/>
                            <span>{{ item.unlockCost }}积分解锁</span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </template>
          </van-list>
          <div v-else-if="state.showEmptyView" class="empty-wrapper">
            <EmptyView class="empty-view" :title="emptyViewTitle" :description="''"/>
          </div>
        </template>
      </div>
    </div>

    <course-material-popup ref="courseMaterialPopup"/>
    <dialog-unlock ref="dialogUnlock" @unlockSuccess="onUnlockSuccess" :dataProps="dataProps"/>
  </div>
</template>

<script>
import {getPfaCategoryTree2, getPfaHotRecommend, getPfaPageList2} from '@/api/pfa.js'
import DatabaseLeftMenu from '@/views/database/modules/DatabaseLeftMenu.vue'
import CourseMaterialPopup from '@/components/CourseMaterialPopup.vue'
import withRouteTracking from '@/utils/withRouteTracking'
import DialogUnlock from '@/components/dialogUnlock.vue'
import {setSha} from '@/utils/util'
import {handleTraceFunction, handleTraceSearchLog} from '@/utils/trace'
import {getShareInfo} from '@/utils/wxShare'
import {Toast} from 'vant'
import {isScorm} from '../../api/scorm'

const PFA_LIST_PAGE_STATE_KEY = 'pfaListPageState'
const HOT_SCROLL_SPEED = 20

const IMG_DEFAULT = require('@/assets/images/defaultImage.png')
const IMG_DEFAULT2 = require('@/assets/images/defaultImage2.png')
const ICON_MAP = {
  1: require('@/assets/images/home/search_view@2x.png'),
  2: require('@/assets/images/home/search_course@2x.png'),
  3: require('@/assets/images/home/search_case@2x.png'),
  5: require('@/assets/images/video.png'),
  6: require('@/assets/images/PPT.png'),
  7: require('@/assets/images/journalArticles.png'),
  8: require('@/assets/images/search_course_t.png')
}

const UserProfile = {
  name: 'PFA',
  components: {
    DatabaseLeftMenu,
    CourseMaterialPopup,
    DialogUnlock
  },
  data() {
    return {
      showSearchBar: false,
      searchValue: '',
      appliedSearchValue: '',
      hotList: [],
      categoryList: [],
      courseCategoryIdFirst: '',
      courseCategoryIdSecond: '',
      courseCategoryIdThird: '',
      sectionList: [],
      activeSectionId: '',
      contentList: [],
      pendingItem: null,
      pendingOptions: null,
      savedTabScrollLeft: 0,
      savedCategoryTreeScrollTop: 0,
      savedContentWrapperScrollTop: 0,
      savedContentScrollTop: 0,
      savedWindowScrollTop: 0,
      lastViewedItemKey: '',
      lastViewedItemOffsetTop: 0,
      expandedMaterialIds: [],
      searchPollSeq: 0, // 仅用于取消进行中的搜索探测，避免过期探测再去切 tab
      dataProps: {
        unlockContent: '兑换PFA内容',
        unlockTxt: '内容'
      },
      state: {
        pageSize: 10,
        pageNum: 1,
        loading: false,
        finished: false,
        finishText: '',
        showEmptyView: false
      }
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    isSecondLevel() {
      return !!this.courseCategoryIdSecond && !this.courseCategoryIdThird
    },
    canSearch() {
      return true
    },
    visibleHotList() {
      return (this.hotList || []).filter(item => item && `${item._title || ''}`.trim())
    },
    hotScrollList() {
      if (this.visibleHotList.length <= 1) return this.visibleHotList
      return [...this.visibleHotList, ...this.visibleHotList]
    },
    emptyViewTitle() {
      if (!this.courseCategoryIdSecond) return '暂无数据'
      const node = this.findCategoryNode(this.categoryList, this.courseCategoryIdSecond)
      if (node && ['STSF双能量', '未来产品'].includes(node.name)) {
        return '感谢您对强生产品的关注，因该产品尚未在中国大陆上市使用，如需更多信息或公开的文献资料，请将您的需求发送至邮箱RA-JNJCNMP-MEDICAL@ITS.JNJ.com，由强生相关人员提供支持。'
      }
      return '暂无数据'
    },
  },
  async mounted() {
    document.addEventListener('click', this.handleDocumentClick)
    this.initShareConfig()

    const restored = await this.restorePageState()
    if (restored) {
      return
    }

    window.sessionStorage.removeItem('pfaListFilter')

    // 从 URL query 参数读取
    const {categoryFirst, categorySecond, categoryThird} = this.$route.query
    if (categoryFirst) this.courseCategoryIdFirst = categoryFirst
    if (categorySecond) this.courseCategoryIdSecond = categorySecond
    if (categoryThird) this.courseCategoryIdThird = categoryThird

    // 加载热门推荐和分类树
    this.getHotRecommend()
    await this.getCategoryTree()

    const hasCurrentCategory = this.categoryList.some(item => item.id === this.courseCategoryIdFirst)

    // 如果当前标签不存在，则默认使用第一个
    if ((!this.courseCategoryIdFirst || !hasCurrentCategory) && this.categoryList.length > 0) {
      this.courseCategoryIdFirst = this.categoryList[0].id
    }

    // 重置并加载数据
    this.state.pageNum = 1
    this.contentList = []
    this.state.finished = true // 临时设置，防止 van-list 初始触发
    this.updateSectionList()
    if (this.shouldFetchContent()) {
      await this.getContentList()
    }
    this.$nextTick(() => this.refreshPfaTabs())
  },
  activated() {
    document.addEventListener('click', this.handleDocumentClick)
    this.restoreScrollPosition()
    window.sessionStorage.removeItem(PFA_LIST_PAGE_STATE_KEY)
    this.$nextTick(() => {
      this.restorePfaTabsPosition()
      this._startHotScroll()
    })
  },
  deactivated() {
    this.closeCourseMaterialPopup()
    this.rememberScrollPosition()
    document.removeEventListener('click', this.handleDocumentClick)
    this._stopHotScroll()
    this._unbindHotScrollEvents()
  },
  beforeDestroy() {
    this.closeCourseMaterialPopup()
    document.removeEventListener('click', this.handleDocumentClick)
    this._stopHotScroll()
    this._unbindHotScrollEvents()
  },
  methods: {
    initShareConfig() {
      window.sessionStorage.setItem('mainId', '')
      window.sessionStorage.setItem('serviceId', '')
      const entrance = this.$route.query.entrance || window.sessionStorage.getItem('entrance') || '163'
      window.sessionStorage.setItem('entrance', entrance)
      window.sessionStorage.setItem('traceTitle', 'PFA图书馆')
      getShareInfo({
        title: 'PFA图书馆',
        titleTimeLine: 'PFA图书馆',
        desc: '汇脉冲精萃，启EP新程',
        link: window.location.href,
        linkTimeLine: window.location.href,
        images: 'https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg'
      })
    },
    async restorePageState() {
      const savedState = window.sessionStorage.getItem(PFA_LIST_PAGE_STATE_KEY)
      if (!savedState) return false

      try {
        const {
          hotList = [],
          categoryList = [],
          courseCategoryIdFirst = '',
          courseCategoryIdSecond = '',
          courseCategoryIdThird = '',
          sectionList = [],
          activeSectionId = '',
          contentList = [],
          state = {},
          showSearchBar = false,
          searchValue = '',
          appliedSearchValue = '',
          tabScrollLeft = 0,
          categoryTreeScrollTop = 0,
          contentWrapperScrollTop = 0,
          contentScrollTop = 0,
          windowScrollTop = 0,
          lastViewedItemKey = '',
          lastViewedItemOffsetTop = 0
        } = JSON.parse(savedState)

        this.hotList = hotList
        this.categoryList = categoryList
        this.courseCategoryIdFirst = courseCategoryIdFirst
        this.courseCategoryIdSecond = courseCategoryIdSecond
        this.courseCategoryIdThird = courseCategoryIdThird
        this.sectionList = sectionList
        this.activeSectionId = activeSectionId
        this.contentList = contentList
        this.showSearchBar = showSearchBar
        this.searchValue = searchValue
        this.appliedSearchValue = appliedSearchValue
        this.state = {
          ...this.state,
          ...state,
          loading: false
        }

        if (!this.hotList.length) {
          await this.getHotRecommend()
        }

        if (!this.categoryList.length) {
          await this.getCategoryTree()
        }

        this.updateSectionList()

        this.savedTabScrollLeft = tabScrollLeft
        this.savedCategoryTreeScrollTop = categoryTreeScrollTop
        this.savedContentWrapperScrollTop = contentWrapperScrollTop
        this.savedContentScrollTop = contentScrollTop
        this.savedWindowScrollTop = windowScrollTop
        this.lastViewedItemKey = lastViewedItemKey
        this.lastViewedItemOffsetTop = lastViewedItemOffsetTop
        this.restoreScrollPosition()
        this.$nextTick(() => {
          this.restorePfaTabsPosition()
          this._startHotScroll()
        })

        return true
      } catch (error) {
        console.error('恢复PFA列表页状态失败:', error)
        return false
      } finally {
        // 恢复完成后立即清除缓存，避免下次进入误用旧数据
        window.sessionStorage.removeItem(PFA_LIST_PAGE_STATE_KEY)
      }
    },

    getPfaTabsVm() {
      if (this.$refs.pfaTabs) return this.$refs.pfaTabs

      const child = this.$children && this.$children[0]
      return child && child.$refs ? child.$refs.pfaTabs : null
    },

    getTabScrollEl() {
      const tabs = this.getPfaTabsVm()
      if (tabs && tabs.$refs && tabs.$refs.nav) return tabs.$refs.nav

      const root = this.$el && this.$el.querySelector ? this.$el : document
      return root.querySelector('.pfa-tabs .van-tabs__nav')
    },

    getPageScrollEls() {
      const root = this.$el && this.$el.querySelector ? this.$el : document
      return {
        tabScrollWrapper: this.getTabScrollEl(),
        contentWrapper: root.querySelector('.content-wrapper'),
        categoryTree: root.querySelector('.category-tree'),
        contentList: root.querySelector('.content-list')
      }
    },

    rememberScrollPosition() {
      this.refreshPfaTabs()

      const {tabScrollWrapper, contentWrapper, categoryTree, contentList} = this.getPageScrollEls()
      if (tabScrollWrapper) {
        this.savedTabScrollLeft = tabScrollWrapper.scrollLeft
      }
      if (contentWrapper) {
        this.savedContentWrapperScrollTop = contentWrapper.scrollTop
      }
      if (categoryTree) {
        this.savedCategoryTreeScrollTop = categoryTree.scrollTop
      }
      if (contentList) {
        this.savedContentScrollTop = contentList.scrollTop
      }
      this.savedWindowScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
    },

    restoreScrollPosition(
      categoryTreeScrollTop = this.savedCategoryTreeScrollTop,
      contentScrollTop = this.savedContentScrollTop
    ) {
      this.savedCategoryTreeScrollTop = Number(categoryTreeScrollTop) || 0
      this.savedContentScrollTop = Number(contentScrollTop) || 0

      const applyScroll = () => {
        const {tabScrollWrapper, contentWrapper, categoryTree, contentList} = this.getPageScrollEls()
        if (tabScrollWrapper) tabScrollWrapper.scrollLeft = this.savedTabScrollLeft
        if (contentWrapper) contentWrapper.scrollTop = this.savedContentWrapperScrollTop
        if (categoryTree) categoryTree.scrollTop = this.savedCategoryTreeScrollTop
        if (contentList) contentList.scrollTop = this.savedContentScrollTop
        window.scrollTo(0, this.savedWindowScrollTop)
        this.restoreLastViewedItemPosition()
      }

      this.$nextTick(() => {
        applyScroll()
        requestAnimationFrame(() => {
          requestAnimationFrame(applyScroll)
        })
      })
    },

    refreshPfaTabs() {
      const tabs = this.getPfaTabsVm()
      if (!tabs) return

      if (tabs.resize) tabs.resize()
      if (tabs.setCurrentIndexByName) tabs.setCurrentIndexByName(`${this.courseCategoryIdFirst}`)
      if (tabs.scrollIntoView) tabs.scrollIntoView(true)
    },

    restorePfaTabsPosition() {
      const apply = () => {
        this.refreshPfaTabs()

        const tabScrollEl = this.getTabScrollEl()
        if (tabScrollEl && this.savedTabScrollLeft > 0) {
          tabScrollEl.scrollLeft = this.savedTabScrollLeft
        }
      }

      this.$nextTick(() => {
        apply()
        requestAnimationFrame(() => {
          apply()
          requestAnimationFrame(apply)
        })
        window.setTimeout(apply, 120)
      })
    },

    getItemDomKey(item) {
      if (!item) return ''
      const type = this.getItemType(item)
      const id = this.getDetailId(item)
      const materialId = item.materialId || ''
      const courseId = item.courseId || ''
      return `${type || 'type'}-${id || 'id'}-${materialId}-${courseId}`
    },

    findItemElByKey(key) {
      if (!key) return null

      const {contentList} = this.getPageScrollEls()
      if (!contentList) return null

      const items = contentList.querySelectorAll('[data-pfa-item-key]')
      for (let i = 0; i < items.length; i++) {
        if (items[i].getAttribute('data-pfa-item-key') === key) {
          return items[i]
        }
      }
      return null
    },

    rememberLastViewedItemPosition(item) {
      const itemKey = this.getItemDomKey(item)
      if (!itemKey) return

      this.lastViewedItemKey = itemKey
      this.rememberScrollPosition()

      const {contentList} = this.getPageScrollEls()
      const itemEl = this.findItemElByKey(itemKey)
      if (!contentList || !itemEl) return

      const listRect = contentList.getBoundingClientRect()
      const itemRect = itemEl.getBoundingClientRect()
      this.lastViewedItemOffsetTop = itemRect.top - listRect.top
    },

    restoreLastViewedItemPosition() {
      if (!this.lastViewedItemKey) return

      const {contentList} = this.getPageScrollEls()
      const itemEl = this.findItemElByKey(this.lastViewedItemKey)
      if (!contentList || !itemEl) return

      const targetOffsetTop = Number(this.lastViewedItemOffsetTop)
      const listRect = contentList.getBoundingClientRect()
      const itemRect = itemEl.getBoundingClientRect()

      if (!isNaN(targetOffsetTop)) {
        contentList.scrollTop += itemRect.top - listRect.top - targetOffsetTop
        return
      }

      contentList.scrollTop += itemRect.top - listRect.top
    },

    savePageState() {
      this.rememberScrollPosition()

      window.sessionStorage.setItem(PFA_LIST_PAGE_STATE_KEY, JSON.stringify({
        hotList: this.hotList,
        categoryList: this.categoryList,
        courseCategoryIdFirst: this.courseCategoryIdFirst,
        courseCategoryIdSecond: this.courseCategoryIdSecond,
        courseCategoryIdThird: this.courseCategoryIdThird,
        sectionList: this.sectionList,
        activeSectionId: this.activeSectionId,
        contentList: this.contentList,
        state: {
          ...this.state,
          loading: false
        },
        showSearchBar: this.showSearchBar,
        searchValue: this.searchValue,
        appliedSearchValue: this.appliedSearchValue,
        tabScrollLeft: this.savedTabScrollLeft,
        categoryTreeScrollTop: this.savedCategoryTreeScrollTop,
        contentWrapperScrollTop: this.savedContentWrapperScrollTop,
        contentScrollTop: this.savedContentScrollTop,
        windowScrollTop: this.savedWindowScrollTop,
        lastViewedItemKey: this.lastViewedItemKey,
        lastViewedItemOffsetTop: this.lastViewedItemOffsetTop
      }))
    },

    enrichItem(item) {
      if (!item) return item
      const enriched = {
        ...item,
        _cover: this.getContentCover(item),
        _coverSecond: this.getSecondLevelContentCover(item),
        _typeIcon: this.getCategoryTypeIcon(item.type),
        _typeName: this.getCategoryTypeName(item.type)
      }
      if (item.courseMaterialList) {
        enriched.courseMaterialList = item.courseMaterialList
          .filter(m => m && `${m.title || ''}`.trim())
          .map(m => ({
            ...m,
            _cover: this.getContentCover(m),
            _typeIcon: this.getCategoryTypeIcon(m.type),
            _typeName: this.getCategoryTypeName(m.type)
          }))
      }
      return enriched
    },

    isPfaMediaMaterialType(type) {
      const value = Number(type)
      return value === 5 || value === 6 || value === 8
    },

    getCategoryTypeName(type) {
      const map = {1: '文献', 2: '课程', 3: '病例', 5: '视频', 6: 'PPT', 7: '文献', 8: '图文'}
      return map[type] || ''
    },

    // 获取类型图标
    getCategoryTypeIcon(type) {
      return ICON_MAP[type] || ICON_MAP[1]
    },

    getContentCover(item, useLargeDefault = false) {
      const defaultCover = useLargeDefault ? IMG_DEFAULT2 : IMG_DEFAULT
      if (!item) return defaultCover

      const coverMaterialUrl = item.coverMaterialUrl || (item.coverMaterial && item.coverMaterial.url)
      if (this.isPfaMediaMaterialType(item.type)) {
        return coverMaterialUrl || defaultCover
      }

      return item.coverMaterialUrl || item.materialUrl || defaultCover
    },
    getSecondLevelContentCover(item) {
      if (!item) return IMG_DEFAULT2

      if (this.isPfaMediaMaterialType(item.type)) {
        return item.coverMaterialUrl || IMG_DEFAULT2
      }

      return IMG_DEFAULT2
    },

    getHotRecommendCover(item) {
      if (!item) return IMG_DEFAULT2

      if (this.isPfaMediaMaterialType(item.type)) {
        return item.coverMaterialUrl || IMG_DEFAULT2
      }

      return item.coverUrl || IMG_DEFAULT2
    },

    getHotRecommendTitle(item) {
      return item && (item.title || item.name) ? (item.title || item.name) : ''
    },

    getVideoPopupCover(item, options = {}) {
      if (options.fromHotRecommend) return this.getHotRecommendCover(item)
      if (options.fromSecondLevel) return this.getSecondLevelContentCover(item)
      return this.getContentCover(item)
    },

    getVisibleCourseMaterialList(list) {
      return (list || []).filter(item => item && `${item.title || ''}`.trim())
    },

    isCaseMaterial(item) {
      return Number(item && item.type) === 3
    },

    getCaseMaterialAuthor(item) {
      return (item && (item.lecturers || item.keynoteSpeaker || item.author)) || ''
    },

    getCaseMaterialHospital(item) {
      if (!item) return ''
      return item.lecturerHospitals || item.hospitalName || (item.hospital && (item.hospital.cnName || item.hospital.name)) || ''
    },

    // 获取热门推荐
    async getHotRecommend() {
      try {
        const res = await getPfaHotRecommend()
        if (res.code === 0 && res.data) {
          this.hotList = res.data.map(item => ({
            ...item,
            _cover: this.getHotRecommendCover(item),
            _title: this.getHotRecommendTitle(item),
            _typeName: this.getCategoryTypeName(item.type || item.materialType)
          }))
          this.$nextTick(() => this._startHotScroll())
        }
      } catch (error) {
        console.error('获取热门推荐失败:', error)
      }
    },

    _startHotScroll() {
      const el = this.$refs.hotScrollEl
      if (!el) return
      this._stopHotScroll()
      this._bindHotScrollEvents(el)

      if (this.visibleHotList.length <= 1) {
        this._resetHotScrollTransform()
        return
      }

      this._hotScrollOffset = this._normalizeHotScrollOffset(this._hotScrollOffset || 0)
      this._applyHotScrollTransform()
      this._hotScrollLastTime = 0
      this._hotScrollRaf = requestAnimationFrame(this._rafHotScroll)
    },

    _bindHotScrollEvents(el) {
      if (this._hotScrollBoundEl === el) return

      this._unbindHotScrollEvents()

      this._hotScrollBoundEl = el
      this._hotScrollTouching = false

      this._hotScrollTouchStart = e => {
        if (this.visibleHotList.length <= 1) return
        this._hotScrollTouching = true
        this._hotScrollTouchStartX = e.touches[0].clientX
        this._hotScrollTouchStartOffset = this._hotScrollOffset || 0
        this._stopHotScroll()
      }

      this._hotScrollTouchMove = e => {
        if (!this._hotScrollTouching) return
        const deltaX = e.touches[0].clientX - this._hotScrollTouchStartX
        this._hotScrollOffset = this._normalizeHotScrollOffset(this._hotScrollTouchStartOffset - deltaX)
        this._applyHotScrollTransform()
      }

      this._hotScrollTouchEnd = () => {
        if (!this._hotScrollTouching) return
        this._hotScrollTouching = false
        this._hotScrollLastTime = 0
        this._hotScrollRaf = requestAnimationFrame(this._rafHotScroll)
      }

      el.addEventListener('touchstart', this._hotScrollTouchStart, { passive: true })
      el.addEventListener('touchmove', this._hotScrollTouchMove, { passive: true })
      el.addEventListener('touchend', this._hotScrollTouchEnd, { passive: true })
      el.addEventListener('touchcancel', this._hotScrollTouchEnd, { passive: true })
    },

    _unbindHotScrollEvents() {
      const el = this._hotScrollBoundEl
      if (!el) return

      el.removeEventListener('touchstart', this._hotScrollTouchStart)
      el.removeEventListener('touchmove', this._hotScrollTouchMove)
      el.removeEventListener('touchend', this._hotScrollTouchEnd)
      el.removeEventListener('touchcancel', this._hotScrollTouchEnd)

      this._hotScrollBoundEl = null
      this._hotScrollTouchStart = null
      this._hotScrollTouchMove = null
      this._hotScrollTouchEnd = null
    },

    _getHotScrollListEl() {
      const el = this.$refs.hotScrollEl
      return el ? el.querySelector('.hot-scroll-list') : null
    },

    _getHotScrollHalfWidth() {
      const list = this._getHotScrollListEl()
      return list ? list.scrollWidth / 2 : 0
    },

    _normalizeHotScrollOffset(offset) {
      const half = this._getHotScrollHalfWidth()
      if (!half) return 0

      const normalized = offset % half
      return normalized < 0 ? normalized + half : normalized
    },

    _applyHotScrollTransform() {
      const list = this._getHotScrollListEl()
      if (!list) return

      list.style.transform = `translate3d(${-this._hotScrollOffset}px, 0, 0)`
    },

    _resetHotScrollTransform() {
      this._hotScrollOffset = 0
      this._hotScrollLastTime = 0
      const list = this._getHotScrollListEl()
      if (list) {
        list.style.transform = 'translate3d(0, 0, 0)'
      }
    },

    _rafHotScroll(timestamp) {
      if (this.visibleHotList.length <= 1) {
        this._resetHotScrollTransform()
        return
      }

      const list = this._getHotScrollListEl()
      if (!list) return

      if (!this._hotScrollLastTime) {
        this._hotScrollLastTime = timestamp
      }

      const elapsed = Math.min(timestamp - this._hotScrollLastTime, 64)
      this._hotScrollLastTime = timestamp
      this._hotScrollOffset = this._normalizeHotScrollOffset(
        (this._hotScrollOffset || 0) + (elapsed * HOT_SCROLL_SPEED) / 1000
      )
      this._applyHotScrollTransform()
      this._hotScrollRaf = requestAnimationFrame(this._rafHotScroll)
    },

    _stopHotScroll() {
      if (this._hotScrollRaf) {
        cancelAnimationFrame(this._hotScrollRaf)
        this._hotScrollRaf = null
      }
      this._hotScrollLastTime = 0
    },

    // 获取分类树
    async getCategoryTree() {
      try {
        const res = await getPfaCategoryTree2()
        if (res.code === 0 && res.data) {
          this.categoryList = res.data
        }
      } catch (error) {
        console.error('获取PFA分类失败:', error)
      }
    },

    openSearchBar() {
      if (!this.canSearch) return

      this.showSearchBar = true
      this.searchValue = this.appliedSearchValue
      this.$nextTick(() => {
        if (this.$refs.searchInput && this.$refs.searchInput.focus) {
          this.$refs.searchInput.focus()
        }
      })
    },

    handleDocumentClick(event) {
      if (!this.showSearchBar) return

      const searchArea = this.$refs.headerSearchArea
      if (searchArea && searchArea.contains(event.target)) {
        return
      }

      this.closeSearchBar()
    },

    async defaultList() {
      this.searchValue = ''
      this.appliedSearchValue = ''
      await this.resetAndFetchList()
    },

    async onSearchEnter() {
      if (!this.canSearch) return

      this.appliedSearchValue = this.searchValue.trim()
      if (!this.appliedSearchValue) {
        await this.resetAndFetchList()
        return
      }
      handleTraceSearchLog({
        'userId': this.userInfo.id,
        'searchContent': this.appliedSearchValue,
        'sessionId': localStorage.getItem('sessionId'),
        'type': 1,
        'entrance': 163,
      })
      // 仅搜索/回车探测一级 tab；有数据且非当前则走原切 tab，否则走当前 tab 原搜索
      const seq = ++this.searchPollSeq
      this.state.loading = true
      Toast.loading({message: '加载中...', duration: 0})
      const hitTab = await this.probeFirstTabWithSearchData(seq, this.appliedSearchValue)
      if (seq !== this.searchPollSeq) return
      // 探测结束后不关 loading，交给后续原查询收尾，避免中间闪一下
      if (hitTab && `${hitTab.id}` !== `${this.courseCategoryIdFirst}`) {
        this.switchTab(hitTab)
        return
      }
      this.courseCategoryIdSecond = ''
      this.courseCategoryIdThird = ''
      await this.resetAndFetchList()
    },

    async clearSearchValue() {
      if (!this.canSearch) return

      this.searchValue = ''
      this.appliedSearchValue = ''
      await this.resetAndFetchList()
    },

    // Vant2 clear 图标仅绑定 touchstart，PC 端点击时做兜底处理
    handleSearchClick(event) {
      const target = event && event.target
      if (!target || !target.classList) return
      if (!target.classList.contains('van-field__clear')) return
      if (!this.searchValue) return

      this.clearSearchValue()
    },

    async onSearchCancel() {
      await this.closeSearchBar()
    },

    async closeSearchBar() {
      const hadAppliedSearch = !!this.appliedSearchValue

      this.showSearchBar = false
      this.searchValue = ''

      if (!hadAppliedSearch) {
        return
      }

      this.appliedSearchValue = ''
      await this.resetAndFetchList()
    },

    // 标签页切换
    onTabClick(name) {
      const item = this.categoryList.find(item => `${item.id}` === `${name}`)
      if (item) {
        this.switchTab(item)
      }
    },

    switchTab(item) {
      if (!item) return
      if (`${this.courseCategoryIdFirst}` === `${item.id}`) {
        this.$nextTick(() => this.refreshPfaTabs())
        return
      }
      const firstSecondCategory = item.children && item.children.length > 0 ? item.children[0] : null
      this.courseCategoryIdFirst = item.id
      this.courseCategoryIdSecond = firstSecondCategory ? firstSecondCategory.id : ''
      this.courseCategoryIdThird = ''
      this.sectionList = []
      this.activeSectionId = ''
      // 切换一级 tab 时，保留已输入的搜索关键词
      // 如果搜索框中有关键词但尚未回车确认，则将其标记为已应用，便于切 tab 后重新拉取列表
      if (this.searchValue && this.searchValue.trim() && !this.appliedSearchValue) {
        this.appliedSearchValue = this.searchValue.trim()
      }
      this.resetAndFetchList()
      this.$nextTick(() => this.refreshPfaTabs())
    },

    // 重置并加载列表
    resetAndFetchList() {
      this.searchPollSeq += 1
      this.state.loading = false
      this.state.finished = false
      this.state.showEmptyView = false
      this.state.pageNum = 1
      this.contentList = []
      if (!this.appliedSearchValue) this.expandedMaterialIds = []
      this.updateSectionList()

      if (!this.shouldFetchContent()) {
        this.state.finished = true
        return
      }

      this.getContentList()
    },

    // 搜索探测顺序：从当前一级 tab 开始往后循环，如 C → D → A → B
    getFirstCategoryPollOrder(startId) {
      const list = this.categoryList || []
      if (!list.length) return []
      const startIndex = list.findIndex(item => `${item.id}` === `${startId}`)
      if (startIndex <= 0) return list
      return list.slice(startIndex).concat(list.slice(0, startIndex))
    },

    tabHasSearchData(res) {
      const list = res && res.code === 0 && res.data && Array.isArray(res.data.list) ? res.data.list : []
      return list.length > 0 || Number(res && res.data && res.data.total) > 0
    },

    // 只探测哪个一级 tab 有数据，不渲染列表
    async probeFirstTabWithSearchData(seq, keyword) {
      const pollTabs = this.getFirstCategoryPollOrder(this.courseCategoryIdFirst)
      for (let i = 0; i < pollTabs.length; i++) {
        if (seq !== this.searchPollSeq) return undefined
        const tab = pollTabs[i]
        try {
          const res = await getPfaPageList2({
            pageNum: 1,
            pageSize: 1,
            dataValue: keyword,
            categoryId: tab.id
          })
          if (seq !== this.searchPollSeq) return undefined
          if (this.tabHasSearchData(res)) return tab
        } catch (error) {
          console.error('搜索探测失败:', error)
          if (seq !== this.searchPollSeq) return undefined
        }
      }
      return null
    },

    // 加载内容列表（van-list @load 触发）
    async getContentList() {
      if (this.state.loading) return
      const fetchSeq = this.searchPollSeq
      this.state.showEmptyView = false
      this.state.loading = true
      const isFirstPage = this.state.pageNum === 1
      if (isFirstPage) Toast.loading({message: '加载中...', duration: 0})

      let categoryId = this.getCurrentCategoryId()

      if (!categoryId) {
        this.contentList = []
        this.state.showEmptyView = false
        this.state.finished = true
        this.state.loading = false
        Toast.clear()
        return
      }

      const isSearch = !!this.appliedSearchValue
      const canDrill = isFirstPage && !isSearch

      try {
        let res = null
        const visited = []
        while (categoryId) {
          if (visited.indexOf(`${categoryId}`) !== -1) break
          visited.push(`${categoryId}`)

          const params = {
            pageNum: this.state.pageNum,
            pageSize: this.state.pageSize,
            dataValue: this.appliedSearchValue,
            ...(isSearch
              ? { categoryId: this.courseCategoryIdFirst }
              : { categoryIds: [categoryId] })
          }

          const requestCategoryId = categoryId
          res = await getPfaPageList2(params)

          if (fetchSeq !== this.searchPollSeq) return
          if (requestCategoryId !== this.getCurrentCategoryId()) return

          const pageList = res && res.code === 0 && res.data && Array.isArray(res.data.list) ? res.data.list : null
          if (canDrill && pageList && pageList.length === 0 && this.canAutoDrillFrom(requestCategoryId)) {
            const nextCategoryId = this.selectFirstChild(requestCategoryId)
            if (nextCategoryId) {
              const thirdNode = this.findCategoryNode(this.categoryList, nextCategoryId)
              if (thirdNode && thirdNode.children && thirdNode.children.length > 0) {
                this.updateSectionList()
                this.contentList = []
                this.state.finished = true
                this.state.showEmptyView = false
                return
              }
              categoryId = nextCategoryId
              continue
            }
          }
          break
        }

        if (!res || res.code !== 0 || !res.data || !res.data.list) {
          this.contentList = []
          this.state.finished = true
          this.state.showEmptyView = true
        } else {
          this.contentList = [...this.contentList, ...res.data.list.map(item => this.enrichItem(item))]
          if (this.appliedSearchValue) {
            const newIds = res.data.list.filter(item => item.courseMaterialList && item.courseMaterialList.length).map(item => item.id)
            newIds.forEach(id => { if (this.expandedMaterialIds.indexOf(id) === -1) this.expandedMaterialIds.push(id) })
          }
          const loadedCount = this.contentList.length
          this.state.finished = res.data.total === 0 ? true : loadedCount >= res.data.total
          this.state.showEmptyView = loadedCount === 0
        }
        this.state.pageNum++
      } catch (error) {
        console.error('获取内容列表失败:', error)
        Toast.fail({message: '加载失败，请稍后再试'})
      } finally {
        if (fetchSeq === this.searchPollSeq) {
          this.state.loading = false
          Toast.clear()
        }
      }
    },

    // 只在「当前停在二级、还没选三级」时自动选中第一个三级
    canAutoDrillFrom(categoryId) {
      return `${categoryId}` === `${this.courseCategoryIdSecond}` && !this.courseCategoryIdThird
    },

    // 二级没有内容时，选中它的第一个三级。返回下一次要查的分类 id
    selectFirstChild(categoryId) {
      const node = this.findCategoryNode(this.categoryList, categoryId)
      const child = node && node.children && node.children[0]
      if (!child || child.id === undefined || child.id === null || `${child.id}` === `${categoryId}`) return ''

      if (`${categoryId}` === `${this.courseCategoryIdSecond}` && !this.courseCategoryIdThird) {
        this.courseCategoryIdThird = child.id
        this.sectionList = []
        this.activeSectionId = ''
        return child.id
      }

      return ''
    },

    shouldFetchContent() {
      if (this.sectionList.length > 0) {
        return !!this.activeSectionId
      }
      return true
    },

    getCurrentCategoryId() {
      if (this.courseCategoryIdThird && this.sectionList.length > 0) {
        return this.activeSectionId
      }
      return this.courseCategoryIdThird || this.courseCategoryIdSecond || this.courseCategoryIdFirst
    },

    updateSectionList() {
      this.sectionList = []

      if (!this.courseCategoryIdThird) {
        this.activeSectionId = ''
        return
      }

      const node = this.findCategoryNode(this.categoryList, this.courseCategoryIdThird)
      if (!node || !node.children || node.children.length === 0) {
        this.activeSectionId = ''
        return
      }

      this.sectionList = node.children

      const hasActive = this.sectionList.some(item => item.id === this.activeSectionId)
      if (!hasActive) {
        this.activeSectionId = ''
      }
    },

    toggleSection(section) {
      if (this.state.loading) return

      const nextSectionId = this.activeSectionId === section.id ? '' : section.id
      this.activeSectionId = nextSectionId
      this.state.loading = false
      this.state.finished = false
      this.state.showEmptyView = false
      this.state.pageNum = 1
      this.contentList = []

      if (!this.shouldFetchContent()) {
        this.state.finished = true
        return
      }

      this.getContentList()
    },

    // 递归查找分类节点
    findCategoryNode(list, id) {
      for (const item of list) {
        if (item.id === id) return item
        if (item.children && item.children.length > 0) {
          const found = this.findCategoryNode(item.children, id)
          if (found) return found
        }
      }
      return null
    },

    getCourseMaterialPopup() {
      if (this.$refs.courseMaterialPopup) return this.$refs.courseMaterialPopup

      const child = this.$children && this.$children[0]
      return child && child.$refs ? child.$refs.courseMaterialPopup : null
    },

    // 弹窗视频埋点前写入 track 参数，handleTraceVideo 会优先读取 video-track-cache
    setPfaVideoTrackCache(item) {
      const routeEntrance = `${this.$route.query.entrance || ''}`
      // 20/21 为微信分享入口，其余默认 PFA 图书馆 163
      const entrance = (routeEntrance === '20' || routeEntrance === '21') ? routeEntrance : '163'
      sessionStorage.setItem('video-track-cache', JSON.stringify({
        entrance,
        channel: '163',
        campId: (item && item.courseCategoryId) || ''
      }))
    },

    closeCourseMaterialPopup() {
      const popup = this.getCourseMaterialPopup()
      if (popup && popup.closeAll) {
        popup.closeAll()
      }
      // 关闭弹窗或离开页面时清理，避免污染其他页面的视频埋点
      sessionStorage.removeItem('video-track-cache')
    },

    beforeRouteLeaveCustom() {
      const child = this.$children && this.$children[0]
      const target = child && child.savePageState ? child : this
      target.closeCourseMaterialPopup()
      target.savePageState()
      return new Promise(resolve => {
        target.$nextTick(() => resolve(true))
      })
    },

    // 跳转详情
    async goDetail(item, options = {}) {
      this.rememberLastViewedItemPosition(item)

      this.tracePfaMaterialClick(item)

      if (`${item.isUnlock}` === '1' && !item.myUnlock) {
        this.pendingItem = item
        this.pendingOptions = options
        this.dataProps.baseId = this.getDetailId(item)
        this.dataProps.unlockCost = item.unlockCost
        this.$refs.dialogUnlock.dailogShow = true
        return
      }
      await this.handleJump(item, options)
    },

    getDetailId(item) {
      return item.baseId || item.id
    },

    getItemType(item) {
      return Number(item && (item.type || item.materialType))
    },

    getMaterialTraceNote(item) {
      return (item && (item.materialId || item.baseId || item.id)) || ''
    },

    tracePfaMaterialClick(item) {
      const type = this.getItemType(item)
      if (!this.isPfaMediaMaterialType(type)) return

      handleTraceFunction({
        functionName: `PFA图书馆-${this.getCategoryTypeName(type)}预览`,
        functionUrl: window.location.href,
        createTime: new Date().getTime(),
        note: this.getMaterialTraceNote(item),
        serviceId: this.getMaterialTraceNote(item),
        campId: (item && item.courseCategoryId) || ''
      })
    },

    async handleJump(item, options = {}) {
      const detailId = this.getDetailId(item)
      const type = this.getItemType(item)
      if (type === 5 || type === 6 || type === 8) {
        const materialId = item.materialId || item.material.id
        if (!materialId) {
          this.$toast('文件信息缺失')
          return
        }
        this.savePageState()
        this.$router.push({
          path: '/filePreview',
          query: {
            materialId,
            entrance: '163',
            channel: '163'
          }
        })
        return
      }
      if (type === 7) {
        this.savePageState()
        this.$router.push({
          path: '/journalArticle',
          query: {
            articleId: item.materialId || detailId,
            businessId: item.courseId,
            entrance: '163',
            channel: '163'
          }
        })
        return
      }
      if (type === 2) {
        // 课程
        const query = {
          courseId: detailId,
          businessId: item.courseCategoryId,
          entrance: '163',
          channel: '163',
          fromPage: 'pfa'
        }
        const isscorm = await isScorm(detailId)
        let path = '/courserDetails'
        if (isscorm.data) {
          path = '/scormCourseDetail'
        }
        this.savePageState()
        this.$router.push({path, query})
      } else if (type === 1) {
        // 文献
        this.savePageState()
        this.$router.push({
          path: '/articleDetails',
          query: {id: detailId, entrance: '163', channel: '163', businessId: item.courseCategoryId}
        })
      } else if (type === 3) {
        // 病例 - 跳转外部病例系统
        this.savePageState()
        const openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${item.materialId || detailId}${openidBindli}&entrance=163&businessChannel=163`
      }
    },

    toggleMaterial(courseId) {
      const idx = this.expandedMaterialIds.indexOf(courseId)
      if (idx === -1) {
        this.expandedMaterialIds.push(courseId)
      } else {
        this.expandedMaterialIds.splice(idx, 1)
      }
    },

    onUnlockSuccess() {
      if (this.pendingItem) {
        this.pendingItem.myUnlock = 1
        this.handleJump(this.pendingItem, this.pendingOptions || {})
        this.pendingItem = null
        this.pendingOptions = null
      }
    }
  }
}

export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.pfa-list {
  min-height: 100vh;
  max-height: 100vh;
  background-color: #f9f8f7;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  // 热门推荐
  .hot-recommend {
    padding: 16px 0 12px 0;
    background: linear-gradient(to bottom, rgba(240, 38, 27, 0.1), #FFFFFF);
    margin-bottom: 10px;

    .hot-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      margin-bottom: 12px;

      .hot-title {
        flex: 1;
        font-size: 17px;
        font-weight: 600;
        color: #000;
        opacity: 0.9;
      }

      .search-icon {
        font-size: 20px;
        color: #333;
        cursor: pointer;

        &.disabled {
          color: #c8c9cc;
          cursor: not-allowed;
        }
      }
    }

    .hot-scroll {
      padding: 0 16px;

      .hot-scroll-inner {
        overflow-x: hidden;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        touch-action: pan-y;
        &::-webkit-scrollbar { display: none; }
      }

      .hot-scroll-list {
        display: inline-flex;
        flex-wrap: nowrap;
        transform: translate3d(0, 0, 0);
        will-change: transform;
      }

      .hot-item {
        flex-shrink: 0;
        width: 132px;
        margin-right: 8px;

        .hot-image {
          position: relative;
          width: 132px;
          height: 75px;
          border-radius: 8px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .hot-tag {
            position: absolute;
            top: 0;
            right: 0;
            background: linear-gradient(45deg, #FBB466 0%, #FD4A29 100%);
            color: #fff;
            font-size: 10px;
            font-weight: 500;
            padding: 3px 6px;
            border-bottom-left-radius: 8px;
            border-top-right-radius: 8px;
            line-height: 10px;
          }
        }

        .hot-item-title {
          margin-top: 6px;
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 13px;
          line-height: 16px;
          font-weight: 500;
          color: #2B2B2B;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          .hot-title-type {
            flex: 0 0 auto;
            padding: 4px;
            border-radius: 3px;
            background: #EB1700;
            color: #fff;
            font-size: 10px;
            font-weight: 500;
            line-height: 1;
          }

          .hot-title-text {
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}

// Vant 组件样式覆盖
/deep/ .van-search {
  padding: 14px 16px;
  background: transparent;

  .van-search__content {
    background-color: #f5f5f5;
    border-radius: 18px;
  }

  .van-field__control::placeholder {
    color: #bbbbbb;
    font-size: 13px;
  }

  .van-field__right-icon {
    padding: 0 6px;
    cursor: pointer;
  }
}

// 可滚动标签栏
.tabs-search-bar {
  flex-shrink: 0;
  background: #fff;
  padding: 10px 8px 0;

  /deep/ .van-search {
    padding: 0;
    background: transparent;
  }

  /deep/ .van-search__content {
    background-color: #f5f5f5;
    border-radius: 18px;
  }
}

.pfa-tabs {
  flex-shrink: 0;
  background-color: #fff;

  /deep/ .van-tabs__wrap {
    height: 60px;
    background-color: #fff;
  }

  /deep/ .van-tabs__nav {
    background-color: #fff;
  }

  /deep/ .van-tabs__nav--line {
    box-sizing: content-box;
    height: 42px;
    padding: 5px 6px 13px;
  }

  /deep/ .van-tab {
    flex: 0 0 auto !important;
    min-width: 88px;
    height: 42px;
    padding: 0 12px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    line-height: 42px;
  }

  /deep/ .van-tabs__content {
    display: none;
  }

  /deep/ .van-tab__text {
    overflow: visible;
    font-size: 14px !important;
  }

  .pfa-tab-title {
    position: relative;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px !important;
    line-height: 42px;
  }

  /deep/ .pfa-tab-title-text {
    font-size: 14px !important;
  }

  .img-btm {
    width: 24px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
  }
}

// 内容区域
.content-wrapper {
  flex: 1;
  display: flex;
  background-color: #fff;
  overflow: hidden;

  // 左侧分类树
  .category-tree {
    width: 140px;
    flex-shrink: 0;
    background-color: #fff;
    padding: 0 8px 16px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  // 右侧内容列表
  .content-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    background-color: #F9F8F7;

    &::-webkit-scrollbar {
      display: none;
    }

    .empty-wrapper {
      flex: 1;
      display: flex;
      justify-content: center;
      padding: 40px 16px 40px;
      box-sizing: border-box;
    }

    .section-accordion {
      background: #fff;
    }

    .section-item {
      background: #F9F8F7;

      &:last-child {
        .section-title {
          border-bottom: none;
        }
      }
    }

    .section-title {
      padding: 10px 16px;
      font-size: 14px;
      font-weight: 500;
      color: #202020;
      background: #fff;
      border-bottom: 1px solid #f2f2f2;
    }

    .section-title-main {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    .section-title-text {
      display: block;
      line-height: 20px;
      word-break: break-all;
      white-space: normal;
    }

    .section-title-text-icon {
      display: inline-block;
      width: 17px;
      height: 18px;
      margin: 1px 1px 1px 0;
      vertical-align: top;
    }

    .section-title-action {
      display: inline-flex;
      align-items: center;
      align-self: flex-end;
      margin-top: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #4597F8;
    }

    .section-title-action-icon {
      width: 8px;
      height: 3.5px;
      margin-left: 4px;
      transition: transform 0.2s ease;
      will-change: transform;
    }

    .section-title-action-icon.reverse {
      transform: rotate(180deg);
    }

    .content-box {
      background: #fff;
      margin-top: 10px;
    }

    .content-box-bg {
      background: #ffffff !important;
    }

    .content-box-mg {
      margin-top: 0 !important;
    }

    .content-box-item {
      display: flex;
      gap: 10px;
      padding: 16px;
      flex-direction: column;
      background: linear-gradient(to bottom, #fcebea, #FFFFFF);
      background-size: 100% 60px;
      background-repeat: no-repeat;
    }

    .content-item {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      cursor: pointer;

      .item-unlock {
        display: flex;
        align-items: center;
        margin-top: 2px;

        .icon-unlock {
          width: 10px;
          margin-right: 4px;
        }

        span {
          color: #EB1700;
          font-size: 10px;
        }
      }

      .content-image {
        position: relative;
        flex-shrink: 0;
        width: 60px;
        height: 60px;
        border-radius: 6px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .play-icon {
          position: absolute;
          width: 20px;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          z-index: 1;
        }

        .content-type-tag {
          position: absolute;
          top: 0;
          right: 0;
          background: rgba(0, 0, 0, 0.55);
          color: #fff;
          font-size: 10px;
          padding: 2px 5px;
          border-radius: 6px 6px 6px 0;
          display: flex;
          align-items: center;
          gap: 3px;

          .tag-icon {
            width: 11px;
            height: 11px;
            object-fit: contain;
          }
        }
      }

      .content-info {
        flex: 1;
        min-width: 0;

        .content-title {
          font-size: 12px;
          font-weight: 500;
          color: #2B2B2B;
          margin-bottom: 3px;
          line-height: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }

        .content-meta {
          font-size: 10px;
          color: #5B5F6A;
          margin-bottom: 0;
          line-height: 14px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .content-meta-row {
          font-size: 10px;
          color: #5B5F6A;
          line-height: 14px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}

/deep/ .content-list .empty-view {
  width: 100%;
  height: auto;
  min-height: 0;
}

/deep/ .content-list .empty-view .txt-title {
  text-align: center;
}

/deep/ .hot-empty-view {
  width: 100%;
  height: 94px;
  min-height: 0;
}

/deep/ .hot-empty-view.empty-view .empty-image {
  width: 128px !important;
}

/deep/ .hot-empty-view.empty-view .empty-txt {
  margin-top: 4px;
  font-size: 12px;
  line-height: 16px;
}

/deep/ .hot-empty-view.empty-view .txt-description {
  margin-top: 0;
}

.material-toggle {
  display: flex;
  justify-content: center;
  padding: 6px 0;
  cursor: pointer;

  .material-toggle-icon {
    font-size: 14px;
    color: #999;
    transition: transform 0.2s ease;

    &.expanded {
      transform: rotate(180deg);
    }
  }
}

.content-item-card {
  cursor: pointer;
  width: 100%;

  .card-image {
    position: relative;
    width: 100%;
    padding-top: 56.25%;
    border-radius: 8px;
    overflow: hidden;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .card-play-icon {
      position: absolute;
      width: 40px;
      height: 40px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }

    .content-type-tag {
      position: absolute;
      top: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.55);
      color: #fff;
      font-size: 10px;
      padding: 2px 5px;
      border-radius: 6px 6px 6px 0;
      display: flex;
      align-items: center;
      gap: 3px;

      .tag-icon {
        width: 11px;
        height: 11px;
        object-fit: contain;
      }
    }
  }

  .card-title {
    font-size: 13px;
    font-weight: 500;
    color: #2B2B2B;
    margin-top: 8px;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pfa/index.vue